/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of TimezonesClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  GetServerDateTimeResponseDto,
  StoreTimeZoneResponseDto,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/* ---- Mocked Client Implementation ---- */

import { ITimezonesClient } from '../../interfaces';
export class TimezonesClientMocked implements ITimezonesClient {
  constructor(baseUrl?: string) {}

  async serverDatetime(timeZoneOffset?: number, cancelToken?: CancelToken): Promise<GetServerDateTimeResponseDto> {
    await delay();
    const now = new Date();
    if (timeZoneOffset) {
      now.setMinutes(now.getMinutes() + timeZoneOffset);
    }
    return {
      dateTime: now.toISOString(),
      date: now.toISOString().split('T')[0],
      time: now.toTimeString().split(' ')[0],
      utcOffset: timeZoneOffset || 0,
    } as GetServerDateTimeResponseDto;
  }

  async storetimezone(storeNumber?: string, franchiseName?: string, cancelToken?: CancelToken): Promise<StoreTimeZoneResponseDto> {
    await delay();
    return {
      storeNumber: storeNumber || 'STORE001',
      timeZone: 'Europe/London',
      utcOffset: 0,
      displayName: 'GMT Standard Time',
      isDaylightSavingTime: false,
    } as StoreTimeZoneResponseDto;
  }

  // ====== Auto-generated stub methods ======



}
